import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { PAD_SCENARIO_SERVICE_ADDRESS } from "constants/app.constants";

import { GetScenarioListKey } from "./useScenarioList";
import { ScenarioStickListKey } from "./useScenarioSticks";

export type ZoneSource = "EVA_RESEARCH" | "ORGANIZATION";

export interface ApplyStickDepthsParams {
  scenarioId: string;
  referenceZone: string;
  verticalOffset: string;
  zoneSource: ZoneSource;
}

const useApplyStickDepths = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      scenarioId,
      referenceZone,
      verticalOffset,
      zoneSource
    }: ApplyStickDepthsParams) => {
      const response = await axios.post(
        `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario/${scenarioId}/apply-stick-depths`,
        { referenceZone, verticalOffset, zoneSource }
      );
      return response.data;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(ScenarioStickListKey);
        await queryClient.invalidateQueries(GetScenarioListKey);
      }
    }
  );
};

export default useApplyStickDepths;
